module.exports = __webpack_public_path__ + "img/time.c6073d01.svg";